export const CHANGE_ORGANISATION = 'CHANGE_ORGANISATION';

export const changeOrganisation = (id) => ({
	type: CHANGE_ORGANISATION,
	id
});